var _defs, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 20,
    viewBox: "0 0 20 20",
    alt: "More Details Icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".more-1{fill:#fff;stroke:#777;stroke-miterlimit:10;stroke-width:1.81px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "more-1",
    cx: -10,
    cy: 10,
    r: 7.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "more-1",
    cx: 10,
    cy: 10,
    r: 7.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "more-1",
    cx: 30,
    cy: 10,
    r: 7.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/More.c382bea1.svg";
export { ForwardRef as ReactComponent };